import React from "react";
import { Redirect } from "react-router-dom";

import arrow from "../images/icon-navigation-chevron-left-small.svg";

class BackHeader extends React.Component {
  renderRedirect = () => {
    if (this.props.target) {
      return <Redirect to={this.props.target} />;
    }
  };

  render() {
    return (
      <div className="back-header-container">
        {this.renderRedirect()}
        <div className="back-header">
          <div className="back-button" onClick={() => this.props.onClick()}>
            <img src={arrow} alt="" />
            <span className="ref-name">{this.props.text}</span>
          </div>
          <span className="info-label">{this.props.infoText}</span>
        </div>
      </div>
    );
  }
}

export default BackHeader;
